import * as React from "react"
import { Box } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"

import { STOCK_STATUS } from "../../@constants"
import { NotAllowedBlock } from "@components"

export default function lastDayStockColumn() {
	return {
		name: 'lastStock',
		label: 'Last day in stock',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'wrap', maxWidth: 50 }
			}),
			customBodyRowRender: (value, row) => <Box sx={{
				color: row.stock === STOCK_STATUS.STOCK ? "text.disabled" : 'text.primary',
				textAlign: 'center'
			}}>
				{ value ? formatDate(value, { isString: true }) : <NotAllowedBlock /> }
			</Box>
		}
	}
}